import { ERROR_MESSAGES } from 'ha/pages/Talk/constants/Errors';
import { makeRequestAction } from './actions';
import { ANOTHER_DATES } from '../constants/Actions';

export default (conversationId, { startDate, endDate }) => (
  dispatch,
  _,
  { apiV2 },
) => {
  dispatch(makeRequestAction.start({ type: ANOTHER_DATES }));

  return apiV2
    .changeConversationDate(conversationId, { startDate, endDate })
    .then(({ data }) =>
      apiV2
        .getConversationMessages(conversationId)
        .then(messages => [data, messages]),
    )
    .then(
      ([
        data,
        {
          data: { messages },
        },
      ]) => {
        dispatch(makeRequestAction.done({ ...data, messages }));
      },
    )
    .catch(({ cause }) => {
      if (
        cause?.response?.errors?.some(
          error => error.detail === 'startDate should not be in the past',
        )
      ) {
        dispatch(
          makeRequestAction.error(ERROR_MESSAGES.startDateInThePastTenant),
        );
      } else if (
        cause?.response?.errors?.some(
          error => error.detail === 'startDate should be before end date',
        )
      ) {
        dispatch(
          makeRequestAction.error(ERROR_MESSAGES.startDateBeforeEndDate),
        );
      } else {
        dispatch(makeRequestAction.error(ERROR_MESSAGES.DEFAULT));
      }
    });
};
